import React, { useRef, useCallback } from 'react'
import { NavLink } from 'react-router-dom'
import useScrolledDown from '../Hooks/useScrolledDown'
import useScrollDirection from '../Hooks/useScrollDirection'
import Link from '../PageComponents/Link'
import { RiMenuLine } from 'react-icons/ri'
import state from '../store'
import { useSnapshot } from 'valtio'

export default function Menu () {
  const { logo, menu, site_name } = useSnapshot(state)
  const scrolledDown = useScrolledDown(100)
  const scrollDirection = useScrollDirection()
  const checkRef = useRef()
  const closeCheckbox = useCallback(
    e => {
      e.preventDefault()
      if (checkRef?.current?.checked) {
        checkRef.current.checked = false
      }
    },
    [checkRef]
  )
  return (
    <nav
      className={`flex fixed w-full z-40 transition-all duration-[0.5s] font-text_readable text-header4 top-0 ${
        scrollDirection === 'down' && scrolledDown
          ? 'opacity-0 pointer-events-none -translate-y-full'
          : scrolledDown
          ? 'shadow-md translate-y-0 text-color_readable bg-color_light '
          : 'translate-y-0 text-color_readable backdrop-blur-lg'
      }`}
    >
      <ul className='max-w-sitemax flex w-full items-center m-auto justify-between py-4 px-2 2xl:px-0 flex-row relative'>
        <li
          key={'home'}
          className='text-header4 lg:text-header3 flex items-center justify-between gap-4'
          onClick={closeCheckbox}
        >
          {logo && (
            <img
              className='w-full h-full object-cover max-w-[64px] max-h-[64px] md:max-w-[128px] md:max-h-[128px]'
              src={logo}
              alt='site logo'
              title={site_name ? site_name : 'site logo'}
            />
          )}
          {site_name && <NavLink to='/'>{site_name}</NavLink>}
        </li>
        {menu?.length !== 0 && (
          <li className='flex flex-col p-0 lg:flex-row  z-10 '>
            <label className='inline-flex items-center cursor-pointer'>
              <input
                ref={checkRef}
                type='checkbox'
                value=''
                className='sr-only peer'
              />
              <div
                onClick={closeCheckbox}
                className='backdrop-blur-lg top-full w-full sm:w-1/2 lg:w-auto left-0 lg:left[unset] p-8 lg:p-0 lg:top-[unset] gap-6 lg:gap-4 absolute lg:relative flex flex-col lg:flex-row transition-all duration-700 -translate-x-full peer-checked:translate-x-0  lg:translate-x-0 lg:peer-checked:translate-x-0 peer-checked:bg-color_light'
              >
                {menu?.map(({ id, url, title }, index) => (
                  <Link key={index} url={url}>
                    {title}
                  </Link>
                ))}
              </div>
              <div className='relative flex items-center justify-center text-color_readable lg:hidden transition-all duration-500 peer-checked:text-blue-600'>
                <RiMenuLine />
              </div>
              {/* <div className="relative flex items-center justify-center lg:hidden w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600">
              <span className='-translate-x-full absolute hidden sm:block'>
                menu
              </span>
            </div> */}
            </label>
          </li>
        )}
      </ul>
    </nav>
  )
}
